import {configValues} from "../../api/Config/apiConfig";

let name = '';
let email = '';
let birthday_date = null;
let phone_number = '';
let address = '';
let number_of_payments_year = 0;
let type = 1;
let values = configValues()
    .then(response => {
        return response.data.body[0];
    });

export const state = {
    name: name,
    email: email,
    birthday_date: birthday_date,
    phone_number: phone_number,
    address: address,
    number_of_payments_year: number_of_payments_year,
    values: values,
    type: type
};

export const mutations = {
    changeName (name) {
        state.name = name
    },
    changeEmail (email) {
        state.email = email
    },
    changeBirthdayDate (birthday_date) {
        state.birthday_date = birthday_date
    },
    changePhoneNumber (phone_number) {
        state.phone_number = phone_number
    },
    changeAddress (address) {
        state.address = address
    },
    changeNumberOfPayments (number_of_payments_year) {
        state.number_of_payments_year = number_of_payments_year
    },
    changeType (type) {
        state.type = type
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
